import FormService from "@/services/FormService"
import { defineStore } from "pinia"
import { useAlertStore } from "./alert"
import { AlertType } from "@/static/Alert"
import { i18n } from "@/i18n"

export const useProfessionalSpace = defineStore("professionalSpace", {
  state: () => ({
    name: null,
    logo: null,
    message: null,
    email: null,
    contactToken: null,
    accountId: null,
  }),

  getters: {},

  actions: {
    getIframe(token: string, successCallback: (url: string) => void) {
      FormService.getHuboFormIframeUrl(token).then(
        (res) => {
          if (res.data.data.url) {
            successCallback(res.data.data.url + "?hidden=HEADER,APP_MENU&origin=USKA&no_redirection=true")
          } else {
            successCallback("")
          }
        },
        (e) => {
          const alerts = useAlertStore()
          switch (e.response.status) {
            case 401:
              alerts.push(AlertType.error, "mauvais token")
              break
            default:
              alerts.push(AlertType.error, i18n.global.t("common.errors.default"), e.message)
              break
          }
        }
      )
    },
    setName(name: string) {
      this.name = name
    },
    setLogo(logo: string) {
      this.logo = logo
    },
    setMessage(content: string) {
      this.message = content
    },
    setEmail(email: string) {
      this.email = email
    },
    setContactToken(token: string) {
      this.contactToken = token
    },
    setAccountId(accountId: number) {
      this.accountId = accountId
    },
  },
})
